import { useTranslations } from "src/apps/hooks/useTranslations";
import { modelTypeToUploaderBoxTitle } from "src/contexts/docsAI/modelTypeToUploaderBoxTitle";
import { OrderModel } from "src/contexts/documentationArea/domain/OrderModel";
import { OrderOtherDocument } from "src/contexts/documentationArea/domain/OrderOtherDocument";
import { OrderPayslip } from "src/contexts/documentationArea/domain/OrderPayslip";

interface OrderBoxHeaderTitleProps {
  order: OrderModel | OrderPayslip | OrderOtherDocument;
}

export const OrderBoxHeaderTitle = ({ order }: OrderBoxHeaderTitleProps) => {
  return computeTitleFromOrder(order);
};

export const computeTitleFromOrder = (
  order: OrderModel | OrderPayslip | OrderOtherDocument,
): string | undefined => {
  if (order.isModel()) return computeTitleFromModelOrder(order);
  if (order.isPayslip()) return computeTitleFromPayslipOrder(order);
  if (order.isOtherDocument()) return computeTitleFromOtherDocumentOrder(order);
};

const computeTitleFromPayslipOrder = (order: OrderPayslip): string => {
  const { t } = useTranslations();
  return t(getPayslipMonthTranslationKeyByMonth(order.getRequest().month), {
    year: order.getRequest().year.toString(),
  });
};

const computeTitleFromOtherDocumentOrder = (order: OrderOtherDocument): string => {
  return order.getRequest().title;
};

const computeTitleFromModelOrder = (order: OrderModel): string => {
  const { t } = useTranslations();
  return t(modelTypeToUploaderBoxTitle[order.getRequest().type]);
};

const PAYSLIP_JAN = "documentation_area.payslip.january";
const PAYSLIP_FEB = "documentation_area.payslip.february";
const PAYSLIP_MAR = "documentation_area.payslip.march";
const PAYSLIP_APR = "documentation_area.payslip.april";
const PAYSLIP_MAY = "documentation_area.payslip.may";
const PAYSLIP_JUN = "documentation_area.payslip.june";
const PAYSLIP_JUL = "documentation_area.payslip.july";
const PAYSLIP_AUG = "documentation_area.payslip.august";
const PAYSLIP_SEP = "documentation_area.payslip.september";
const PAYSLIP_OCT = "documentation_area.payslip.october";
const PAYSLIP_NOV = "documentation_area.payslip.november";
const PAYSLIP_DEC = "documentation_area.payslip.december";

const MONTH_JAN = "documentation_area.january";
const MONTH_FEB = "documentation_area.february";
const MONTH_MAR = "documentation_area.march";
const MONTH_APR = "documentation_area.april";
const MONTH_MAY = "documentation_area.may";
const MONTH_JUN = "documentation_area.june";
const MONTH_JUL = "documentation_area.july";
const MONTH_AUG = "documentation_area.august";
const MONTH_SEP = "documentation_area.september";
const MONTH_OCT = "documentation_area.october";
const MONTH_NOV = "documentation_area.november";
const MONTH_DEC = "documentation_area.december";

export const getMonthTranslationKeyByMonth = (month: string) => {
  const monthsMap = new Map([
    ["01", MONTH_JAN],
    ["02", MONTH_FEB],
    ["03", MONTH_MAR],
    ["04", MONTH_APR],
    ["05", MONTH_MAY],
    ["06", MONTH_JUN],
    ["07", MONTH_JUL],
    ["08", MONTH_AUG],
    ["09", MONTH_SEP],
    ["10", MONTH_OCT],
    ["11", MONTH_NOV],
    ["12", MONTH_DEC],
  ]);
  const title = monthsMap.get(month);
  if (!title) {
    throw new Error("Invalid month");
  }
  return title;
};

export const getPayslipMonthTranslationKeyByMonth = (month: string) => {
  const monthsMap = new Map([
    ["01", PAYSLIP_JAN],
    ["02", PAYSLIP_FEB],
    ["03", PAYSLIP_MAR],
    ["04", PAYSLIP_APR],
    ["05", PAYSLIP_MAY],
    ["06", PAYSLIP_JUN],
    ["07", PAYSLIP_JUL],
    ["08", PAYSLIP_AUG],
    ["09", PAYSLIP_SEP],
    ["10", PAYSLIP_OCT],
    ["11", PAYSLIP_NOV],
    ["12", PAYSLIP_DEC],
  ]);
  const title = monthsMap.get(month);
  if (!title) {
    throw new Error("Invalid month");
  }
  return title;
};
